// tokens/component-map.token.ts
import { InjectionToken, Type } from '@angular/core';

export type ComponentMap = Record<string, Type<unknown> | undefined>;

export const COMPONENT_MAP_TOKEN = new InjectionToken<ComponentMap>('COMPONENT_MAP_TOKEN');
